// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"453":"operations","595":"materials","691":"colors","809":"users","852":"orders","964":"product"}[chunkId] + "." + {"453":"f4001f35","595":"6e8b69d3","691":"d9e4fb49","809":"e0aee596","852":"80de14f7","964":"00810e16"}[chunkId] + ".css";
};